import { asFn } from '../../common/utils';
import { makeOverridableFactory } from '../../common/utils/make-overridable-factory';
export const defineComponent = (name, definitionOrGetter) => {
  const platformName = typeof definitionOrGetter === 'function' ? undefined : definitionOrGetter === null || definitionOrGetter === void 0 ? void 0 : definitionOrGetter.platformName;
  // If definition is an object, lift it to `() => def` otherwise leave intact
  const buildDefinition = asFn(definitionOrGetter);
  // Wrap the definition with makeOverridableFactory and override the name with the provided one
  const overridableDefinition = makeOverridableFactory((...args) => {
    const def = buildDefinition(...args);
    return Object.assign({}, def, {
      name
    });
  });
  // Add a getName method that returns the provided name
  const getName = () => name;
  const getPlatformName = () => platformName;
  return Object.assign(overridableDefinition, {
    getName,
    getPlatformName
  });
};